/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { QueryBuilder } from "mst-gql"
import { OrderDeliveryDateMetadataDtoModelType } from "./OrderDeliveryDateMetadataDtoModel"
import { OrderDeliveryDateMetadataDtoModelSelector, orderDeliveryDateMetadataDtoModelPrimitives } from "./OrderDeliveryDateMetadataDtoModel.base"
import { ScheduleActionMetadataDtoModelType } from "./ScheduleActionMetadataDtoModel"
import { ScheduleActionMetadataDtoModelSelector, scheduleActionMetadataDtoModelPrimitives } from "./ScheduleActionMetadataDtoModel.base"

export type OutputMetadataUnionUnion = ScheduleActionMetadataDtoModelType | OrderDeliveryDateMetadataDtoModelType

export class OutputMetadataUnionModelSelector extends QueryBuilder {
  scheduleActionMetadataDto(builder?: string | ScheduleActionMetadataDtoModelSelector | ((selector: ScheduleActionMetadataDtoModelSelector) => ScheduleActionMetadataDtoModelSelector)) { return this.__inlineFragment(`ScheduleActionMetadataDto`, ScheduleActionMetadataDtoModelSelector, builder) }
  orderDeliveryDateMetadataDto(builder?: string | OrderDeliveryDateMetadataDtoModelSelector | ((selector: OrderDeliveryDateMetadataDtoModelSelector) => OrderDeliveryDateMetadataDtoModelSelector)) { return this.__inlineFragment(`OrderDeliveryDateMetadataDto`, OrderDeliveryDateMetadataDtoModelSelector, builder) }
}
export function selectFromOutputMetadataUnion() {
  return new OutputMetadataUnionModelSelector()
}

// provides all primitive fields of union member types combined together
export const outputMetadataUnionModelPrimitives = selectFromOutputMetadataUnion().scheduleActionMetadataDto(scheduleActionMetadataDtoModelPrimitives).orderDeliveryDateMetadataDto(orderDeliveryDateMetadataDtoModelPrimitives)